
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-wfsserver_service",
  "use": "icon-rescls-wfsserver_service-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-rescls-wfsserver_service\"><path fill=\"#106a90\" d=\"M15 13.098V9.902c.571-.215 1-.773 1-1.402 0-.804-.696-1.5-1.5-1.5-.636 0-1.2.406-1.409 1H8v5.092A1.497 1.497 0 0 0 8.5 16c.629 0 1.187-.429 1.402-1h3.189c.203.571.737 1 1.408 1 .804 0 1.5-.696 1.5-1.5.001-.629-.428-1.187-.999-1.402M13.092 9c.148.419.477.757.908.909v3.183a1.5 1.5 0 0 0-.909.909H9.902A1.55 1.55 0 0 0 9 13.098V9z\" /><g fill=\"#00B77E\"><circle cx=\"8.5\" cy=\"8.5\" r=\"1.5\" /><path d=\"M6 8.5C6 7.121 7.121 6 8.5 6c.512 0 1.001.167 1.41.454H12L5.95 0 0 6.454h3.025v7.059H7v-3.018A2.5 2.5 0 0 1 6 8.5\" /></g></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-wfsserver_service"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-wfsserver_service";

        export default Icon;
    